import { OpenFeature } from "@openfeature/react-sdk";
import { FLAGS, FLAG_DEFAULTS, getDefaultTraceSamplingRatePercent } from "../flags";

/**
 * Non-hook helper for reading boolean feature flags outside React components.
 * Uses the OpenFeature provider configured at app startup (src/index.tsx).
 */

export function getBooleanFlag(flagKey: string, defaultValue: boolean): boolean {
  return OpenFeature.getClient().getBooleanValue(flagKey, defaultValue);
}

export function isGeojsonBackendHydrationEnabled(): boolean {
  return getBooleanFlag(FLAGS.GEOJSON_BACKEND_HYDRATION, FLAG_DEFAULTS[FLAGS.GEOJSON_BACKEND_HYDRATION]);
}

export function isGeojsonPerfLogEnabled(): boolean {
  return getBooleanFlag(FLAGS.GEOJSON_PERF_LOG, FLAG_DEFAULTS[FLAGS.GEOJSON_PERF_LOG]);
}

export function isTileLayerFallbackTransitionsEnabled(): boolean {
  return getBooleanFlag(FLAGS.TILE_LAYER_FALLBACK_TRANSITIONS, FLAG_DEFAULTS[FLAGS.TILE_LAYER_FALLBACK_TRANSITIONS]);
}

export function isLightningBinaryRendererEnabled(): boolean {
  return getBooleanFlag(FLAGS.LIGHTNING_BINARY_RENDERER, FLAG_DEFAULTS[FLAGS.LIGHTNING_BINARY_RENDERER]);
}

export function getTelemetryFlags(): {
  telemetryEnabled: boolean;
  tracesEnabled: boolean;
  metricsEnabled: boolean;
  logsEnabled: boolean;
  samplingRatePercent: number;
  logsSamplingRatePercent: number;
  webVitalsSamplingRatePercent: number;
} {
  const telemetryEnabled = getBooleanFlag(FLAGS.TELEMETRY_ENABLED, FLAG_DEFAULTS[FLAGS.TELEMETRY_ENABLED]);
  const tracesEnabled = getBooleanFlag(FLAGS.TELEMETRY_TRACES_ENABLED, FLAG_DEFAULTS[FLAGS.TELEMETRY_TRACES_ENABLED]);
  const metricsEnabled = getBooleanFlag(
    FLAGS.TELEMETRY_METRICS_ENABLED,
    FLAG_DEFAULTS[FLAGS.TELEMETRY_METRICS_ENABLED],
  );
  const logsEnabled = getBooleanFlag(FLAGS.TELEMETRY_LOGS_ENABLED, FLAG_DEFAULTS[FLAGS.TELEMETRY_LOGS_ENABLED]);
  const samplingRatePercent = OpenFeature.getClient().getNumberValue(
    FLAGS.TELEMETRY_TRACES_SAMPLING_RATE_PERCENT,
    getDefaultTraceSamplingRatePercent(),
  );
  const logsSamplingRatePercent = OpenFeature.getClient().getNumberValue(
    FLAGS.TELEMETRY_LOGS_SAMPLING_RATE_PERCENT,
    FLAG_DEFAULTS[FLAGS.TELEMETRY_LOGS_SAMPLING_RATE_PERCENT],
  );
  const webVitalsSamplingRatePercent = OpenFeature.getClient().getNumberValue(
    FLAGS.TELEMETRY_WEB_VITALS_SAMPLING_RATE_PERCENT,
    FLAG_DEFAULTS[FLAGS.TELEMETRY_WEB_VITALS_SAMPLING_RATE_PERCENT],
  );
  return {
    telemetryEnabled,
    tracesEnabled,
    metricsEnabled,
    logsEnabled,
    samplingRatePercent,
    logsSamplingRatePercent,
    webVitalsSamplingRatePercent,
  };
}
